import { forwardRef, type PropsWithChildren } from "react";
import { CloseOutlined } from "@ant-design/icons";
import clsx from "clsx";
import { useIsUnifiedMode } from "@shared/utils";
import "./journal-record-page-shell.scss";

type JournalRecordPageShellProps = PropsWithChildren<{
  onClose?: () => void;
  historical?: boolean;
  className?: string;
  contentClassName?: string;
}>;

export const JournalRecordPageShell = forwardRef<
  HTMLDivElement,
  JournalRecordPageShellProps
>((
  { children, onClose, historical, className, contentClassName },
  ref,
) => {
  const isUnifiedMode = useIsUnifiedMode();

  return (
    <div
      ref={ref}
      className={clsx(
        "journal-record-page-shell",
        historical && "journal-record-page-shell--historical",
        isUnifiedMode && "journal-record-page-shell--unified",
        className,
      )}
    >
      {onClose ? (
        <CloseOutlined
          className="journal-record-page-shell__close"
          onClick={onClose}
        />
      ) : null}
      <div
        className={clsx("journal-record-page-shell__content", contentClassName)}
      >
        {children}
      </div>
    </div>
  );
});
